export const CLASS_UTILITY = `
  /*---------- Custom unility class/Taiwin Css: https://tailwindcss.com/docs ------*/
  /*----------Margin, Padding--------------------*/
  .m-p-0 {
    margin: 0;
    padding: 0;
  }
  .p-40-32 {
    padding: 40px 32px 40px 32px;
  }
  .m-0 {
    margin: 0;
  }
  .m-2 {
    margin: 2px;
  }
  .m-32-36-54-32 {
    margin: 32px 36px 54px 32px;
  }
  .ml-2 {
    margin-left: 0.5rem !important;
  }
  .ml-6 {
    margin-left: 6px;
  }
  .ml-12 {
    margin-left: 12px;
  }
  .ml-24 {
    margin-left: 24px !important;
  }
  .ml-40 {
    margin-left: 40px;
  }
  .ml-30 {
    margin-left: 30px;
  }
  .ml-260 {
    margin-left: 260px;
  }
  .mr-3 {
    margin-right: 0.75rem;
  }
  .mx-6 {
    margin-left: 6px;
    margin-right: 6px;
  }
  .mr-4 {
    margin-right: 1rem;
  }
  .mr-8 {
    margin-right: 2rem;
  }
  .mx-12 {
    margin-left: 12px;
    margin-right: 12px;
  }
  .mx-24 {
    margin-left: 24px;
    margin-right: 24px;
  }
  .mb-1 {
    margin-bottom: 0.25rem;
  }
  .mb-4 {
    margin-bottom: 4px;
  }
  .mb-8 {
    margin-bottom: 8px;
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .m-14-l-10 {
    margin: 14px 10px 14px 10px;
  }
  .p-10 {
    padding: 10px;
  }
  .p-33 {
    padding: 33px;
  }
  .px-5 {
    padding-left: 5px;
    padding-right: 5px;
  }
  .px-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .px-10 {
    padding-left: 10px;
    padding-right: 10px;
  }
  .px-60 {
    padding-left: 60px;
    padding-right: 60px;
  }
  .py-16 {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .pl-8 {
    padding-left: 8px;
  }
  .py-2 {
    padding-top: 2px;
    padding-bottom: 2px;
  }
  .pt-4 {
    padding-top: 4px !important;
  }
  .pt-6 {
    padding-top: 1.5rem;
  }
  .pt-8 {
    padding-top: 2rem;
  }
  .pt-40 {
    padding-top: 40px;
  }
  .pb-8 {
    padding-bottom: 2rem;
  }
  .pb-14 {
    padding-bottom: 3.5rem;
  }
  .pb-16 {
    padding-bottom: 4rem;
  }
  .p-15-12-16-55 {
    padding: 15px 12px 16px 55px;
  }
  .mx-24 {
    margin-left: 24px;
    margin-right: 24px;
  }
  .my-28-40 {
    margin-top: 28px;
    margin-bottom: 40px;
  }
  .my-16 {
    margin-top: 16px !important;
    margin-bottom: 16px !important;
  }
  .ml-19 {
    margin-left: 19px;
  }
  .mb-2 {
    margin-bottom: 0.5rem;
  }
  .mb-5 {
    margin-bottom: 5px;
  }
  .mb-32 {
    margin-bottom: 32px;
  }
  .mb-35 {
    margin-bottom: 35px;
  }
  .mb-40 {
    margin-bottom: 40px;
  }
  .mb-60 {
    margin-bottom: 60px;
  }
  .mb-115 {
    margin-bottom: 115px;
  }
  .my-20 {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .my-60-92 {
    margin-top: 60px;
    margin-bottom: 92px;
  }
  .mb-48 {
    margin-bottom: 48px;
  }
  .mb-14 {
    margin-bottom: 14px;
  }
  .mt-1 {
    margin-top: 0.25rem;
  }
  .mt-2 {
    margin-top: 0.5rem;
  }
  .mt-4 {
    margin-top: 4px;
  }
  .mt-8 {
    margin-top: 8px;
  }
  .mt-16 {
    margin-top: 16px !important;
  }
  .mt-19 {
    margin-top: 19px;
  }
  .mt-32 {
    margin-top: 32px;
  }
  .mt-50 {
    margin-top: 50px;
  }
  .mt-378 {
    margin-top: 378px;
  }
  .mt-39 {
    margin-top: 39px;
  }
  .mt-24 {
    margin-top: 24px;
  }
  .-mt-8 {
    margin-top: -8px;
  }
  .-mt-32 {
    margin-top: -32px;
  }
  .-mt-\\[32px\\] {
    margin-top: -32px;
  }
  .mb-0 {
    margin-bottom: 0;
  }
  .mb-39 {
    margin-bottom: 39px;
  }
  .mb-41 {
    margin-bottom: 41px;
  }
  .m-24 {
    margin: 24px;
  }
  .ml-16 {
    margin-left: 16px;
  }
  .ml-12 {
    margin-left: 12px;
  }
  .mb-47 {
    margin-bottom: 47px;
  }
  .mb-9 {
    margin-bottom: 9px;
  }
  .mb-32 {
    margin-bottom: 32px;
  }
  .p-0 {
    padding: 0 !important;
  }
  .p-20 {
    padding: 20px;
  }
  .p-24 {
    padding: 24px;
  }
  .pr-4 {
    padding-right: 1rem;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .cover {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  /*----------Flex Box------*/
  .flex {
    display: flex !important;
  }
  .flex-center {
    align-items: center !important;
    justify-content: center !important;
  }
  .inline-block	{
    display: inline-block;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: end;
  }
  .justify-center	{
    justify-content: center;
  }
  .justify-between	{
    justify-content: space-between;
  }
  .justify-around	{
    justify-content: space-around;
  }
  .justify-end	{
    justify-content: flex-end !important;
  }
  .flex-row {
    flex-direction: row !important;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .flex-row-reverse {
    flex-direction: row-reverse;
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-col-reverse {
    flex-direction: column-reverse;
  }
  /*----------Position------*/
  .static {
    position: static;
  }
  .fixed {
    position: fixed;
  }
  .absolute {
    position: absolute !important;
  }
  .relative {
    position: relative !important;
  }
  .sticky {
    position: sticky;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .cursor-grab {
    cursor: grab !important;
  }
  .cursor-grabbing {
    cursor: grabbing !important;
  }
  /*-------------------List Style Type------------------------*/
  .list-none {
    list-style-type: none;
  }
  /*-------------------Top / Right / Bottom / Left------------*/
  .inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .inset-y-0 {
    top: 0;
    bottom: 0;
  }
  .inset-x-0 {
    right: 0;
    left: 0;
  }
  .top-0 {
    top: 0;
  }
  .top-8 {
    top: 8px;
  }
  .top-1 {
    top: 4px;
  }
  .top-2 {
    top: 0.5rem;
  }
  .top-4 {
    top: 1rem;
  }
  .top-\\[6px\\] {
    top: 6px;
  }
  .right-0 {
    right: 0;
  }
  .right-8 {
    right: 8px;
  }
  .right-32 {
    right: 8rem !important;
  }
  .right-36 {
    right: 9rem !important;
  }
  .right-\\[10\\%\\] {
    right: 10%;
  }
  .right-1\\/4 {
    right: 25%;
  }
  .right-2 {
    right: 0.5rem;
  }
  .right-4 {
    right: 1rem;
  }
  .right-12 {
    right: 3rem;
  }
  .bottom-0 {
    bottom: 0;
  }
  .bottom-2 {
    bottom: 0.5rem;
  }
  .left-0 {
    left: 0;
  }
  .left-4 {
    left: 1rem;
  }
  .inset-auto {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }
  /*-------------------------text-------------------------------*/
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .text-transparent {
    color: transparent;
  }
  .text-black {
    color: #000;
  }
  .text-white {
    color: #fff !important;
  }
  .text-collapse {
    color: #044067 !important;
  }
  .text-red {
    color: red !important;
  }
  .text-15 {
    font-size: 15px;
  }
  .text-11 {
    font-size: 11px;
  }
  .text-12 {
    font-size: 12px;
  }
  .text-14 {
    font-size: 14px;
  }
  .text-15 {
    font-size: 15px;
  }
  .text-16 {
    font-size: 16px !important;
  }
  .text-17 {
    font-size: 17px !important;
  }
  .text-18 {
    font-size: 18px !important;
  }
  .text-20 {
    font-size: 20px;
  }
  .text-24 {
    font-size: 24px;
  }
  .text-30 {
    font-size: 30px !important;
  }
  .text-80 {
    font-size: 80px;
  }
  .font-semibold {
    font-weight: 600;
  }
  .weight-700 {
    font-weight: 700 !important;
  }
  .weight-450 {
    font-weight: 450;
  }
  .truncate-250 {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .truncate-down {
    display: inline;
    -webkit-line-clamp: 10;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
  }
  .line-clamp-3 {   
    display: -webkit-box;   
    -webkit-line-clamp: 3;   
    -webkit-box-orient: vertical;     
    overflow: hidden; 
  }
  .underline {
    text-decoration: underline;
    color: #000;
  }
  /*--------------------Border---------------------------------*/
  .border {
    border-width: 1px;
  }
  .border-2 {
    border-width: 2px;
  }
  .border-solid {
    border-style: solid;
  }
  .border-black {
    border-color: #000;
  }
  .border-slate-600 {
    border-color: rgb(71 85 105) !important;
  }
  .border-slate-700 {
    border-color: rgb(51 65 85) !important;
  }
  .border-slate-800 {
    border-color: rgb(30 41 59) !important;
  }
  .border-gray-600 {
    border-color: rgb(75 85 99) !important;
  }
  .border-gray-800 {
    border-color: rgb(31 41 55) !important;
  }
  .border-neutral-800 {
    border-color: #ccc !important;
  }
  .rounded-sm {
    border-radius: 0.125rem !important;
  }
  .rounded {
    border-radius: 0.25rem !important;
  }
  .rounded-4 {
    border-radius: 0.5rem !important;
  }
  .rounded-8 {
    border-radius: 8px;
  }
  .rounded-10 {
    border-radius: 10px !important;
  }
  .rounded-16 {
    border-radius: 16px;
  }
  .border-tr {
    border-top-width: 1px;
    border-right-width: 1px;
    border-style: solid;
  }
  .border-br-solid-gray-550  {
    border-bottom: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
  }
  .border-t-solid-gray-550 {
    border-top: 1px solid #e9e9e9;
  }
  .border-b-solid-neutral-300 {
    border-bottom: 0.5px solid rgb(212 212 212);
  }
  .border-b-solid-gray-550 {
    border-bottom: 1px solid #e9e9e9;
  }
  .border-r-solid-gray-550  {
    border-right: 1px solid #e9e9e9;
  }
  .border-none {
    border: none;
  }
  /*--------------------Line Height----------------------------*/
  .leading-none	{
    line-height: 1;
  }
  .leading-tight	{
    line-height: 1.25;
  }  
  .leading-snug	{
    line-height: 1.375;
  }
  .leading-normal	{
    line-height: 1.5;
  }
  .leading-relaxed	{
    line-height: 1.625;
  }
  .leading-loose	{
    line-height: 2;
  }
  /*-------------------------Width-------------------------------*/
  .w-half {
    width: 50%;
  }
  .w-auto {
    width: auto;
  }
  .w-58 {
    width: 58px;
  }
  .w-\\[130px\\] {
    width: 130px;
  }
  .w-155 {
    width: 155px;
  }
  .h-screen {
    height: 100vh;
  }
  .h-20 {
    height: 20px;
  }
  .min-h-400 {
    min-height: 400px;
  }
  .min-h-500 {
    min-height: 500px;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .w-full {
    width: 100% !important;
  }
  .max-w-full {
    max-width: 100% !important;
  }
  .max-w-\\[14\\%\\] {
    max-width: 14% !important;
  }
  .w-\\[90\\%\\] {
    width: 90% !important;
  }
  .w-screen {
    width: 100vw;
  }
  .w-1\\/2 {
     width: 50%; 
  }
  .w-1\\/3 {
     width: 33.333333%; 
  }
  .w-10\\/12 {
     width: 83.333333%;
  }
  .w-11\\/12 {
     width: 91.666667%;
  }
  .w-screen {
    width: 100vw;
  }
  .w-400 {
    width: 400px;
  }
  .w-100 {
    width: 100%;
  }
  .w-100-important {
    width: 100% !important;
  }
  .w-150 {
    width: 150px;
  }
  .w-62 {
    width: 62px;
  }
  .w-500 {
    width: 500px;
  }
  .w-\\[280px\\] {
    width: 280px;
  }
  .min-w-145 {
    min-width: 145px;
  }
  /*-------------------------Height-------------------------------*/
  .h-22 {
    height: 22px;
  }
  .h-31 {
    height: 31px;
  }
  .h-48 {
    height: 48px !important;
  }
  .h-68 {
    height: 68px !important;
  }
  .h-80 {
    height: 80px !important;
  }
  .h-100 {
    height: 100px !important;
  }
  .h-200 {
    height: 200px !important;
  }
  .h-230 {
    height: 230px !important;
  }
  .h-250 {
    height: 250px !important;
  }
  .h-405 {
    height: 405px;
  }
  .h-368 {
    height: 368px;
  }
  .h-300 {
    height: 300px !important;
  }
  .h-400 {
    height: 400px !important;
  }
  .h-500 {
    height: 500px !important;
  }
  .h-full {
    height: 100%;
  }
  .h-fit {
    height: fit-content !important;
  }
  .min-h-fit {
    min-height: fit-content !important;
  }
  /*----------------------Background----------------------------*/
  .bg-auto {
    background-size: auto;
  }
  .bg-cover	{
    background-size: cover;
  }
  .bg-contain {
    background-size: contain;
  }
  .bg-contain {
    background-size: contain;
  }
  .bg-neutral-50 {
    background-color: rgb(250 250 250) !important;
  }
  .bg-neutral-100 {
    background-color: rgb(245 245 245) !important;
  }
  .bg-neutral-300 {
    background-color: rgb(212 212 212) !important;
  }
  .bg-gray-200 {
    background: #edf2f7 !important;
  }
  .bg-gray-250 {
    background: #eeeff0;
  }
  .bg-gray-300 {
    background-color: #e2e8f0;
  }
  .bg-gray-650 {
    background: #717791 !important;
  }
  .bg-gray {
    background: #999;
  }
  .bg-white {
    background-color: #fff;	
  }
  .bg-transparent {
    background-color: transparent;	
  }
  .opacity-5 {
    opacity: .05;
  }
  .opacity-70 {
    opacity: .7;
  }
  .opacity-75	{
    opacity: .75;
  }
  .opacity-50	{
    opacity: .5;
  }
  .opacity-25	{
    opacity: .25;
  }
  .object-contain {
    object-fit: contain;
  }
  .object-cover {
    object-fit: cover;
  }
  .object-fill {
    object-fit: fill;
  }
  .object-none {
    object-fit: none;
  }
  .object-scale-down {
    object-fit: scale-down;
  }
  .outline-none {
    outline: none;
  }
  .border-none {
    border: none;
  }
  .border-none {
    border: none;
  }
  .r-2 {
    border-radius: 2px;
  }
  .rounded-5 {
    border-radius: 5px;
  }
  .rounded-8-top {
    border-radius: 8px 8px 0 0;
  }
  .rounded-8 {
    border-radius: 8px;
  }
  /*-----------------------Box shadow---------------------------*/
  .shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .shadow-2 {
    box-shadow: 0px 0px 20px rgba(33, 33, 33, 0.1);
  } 
  .shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  /*--------------------Overflow----------------------------------*/
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-x-scroll {
    overflow-x: auto;
    overflow-y: hidden;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .d-none {
    display: none !important;
  }
  .d-flex {
    display: flex !important;
  }
  .column {
    flex-direction: column;
  }
  .center {
    align-items:center;
    justify-content:center;
  }
  .margin-auto {
    margin: auto;
  }
  .flex-1 {
    flex:1;
  }
  .img-contain {
    object-fit:contain;
  }
  .gap-12 {
    grid-gap: 0.75rem;
  }
  /*--------------------Z-index----------------------------------*/
  .z-10 {
    z-index: 10 !important;
  }
  .z-999 {
    z-index: 999 !important;
  }
  .border-toolbar {
    border: 0.5px solid rgb(212 212 212) !important;
    border-radius: 0.5rem !important;
  }
  .border-editor {
    border: 0.5px solid rgb(212 212 212) !important;
    border-top-left-radius: 0.5rem !important;
    border-top-right-radius: 0.5rem !important;
    border-bottom: none !important;
  }
  .border-editor.special-border-editor {
    border: 0.5px solid rgb(212 212 212) !important;
    border-radius: 0.5rem !important;
  }
  .border-editor-bottom {
    border: 0.5px solid rgb(212 212 212);
    border-top: none;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    background: rgba(250, 250, 250);
  }
  .rdw-embedded-modal-header,
  .rdw-embedded-modal-link-input {
    font-size: 14px !important;
  }
  .rdw-embedded-modal-btn {
    border-radius: 0.4rem !important;
  }
  .rdw-link-modal-header,
  .rdw-link-modal-link-input {
    font-size: 14px !important;
  }
  .rdw-link-modal-btn {
    border-radius: 0.4rem !important;
  }
  .rdw-image-modal-header,
  .rdw-image-modal-link-input {
    font-size: 14px !important;
    margin: 0 !important;
  }
  .rdw-image-modal-btn {
    border-radius: 0.4rem !important;
  }
  .public-DraftStyleDefault-block {
    margin: 0.5rem !important;
  }

  /* font-size */
  .text-xs {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
  }

  .text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .text-base {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }

  .text-lg {
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
  }

  .text-xl {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
  }

  .text-2xl {
    font-size: 1.5rem !important;
    line-height: 2rem !important;
  }

  .text-3xl {
    font-size: 1.875rem !important;
    line-height: 2.25rem !important;
  }

  .text-6xl {
    font-size: 3.75rem !important; /* 60px */
    line-height: 1 !important;
  }

  .text-7xl {
    font-size: 4.5rem !important; /* 60px */
    line-height: 1 !important;
  }

  /* font-weight */
  .font-bold {
    font-weight: 700 !important;
  }

  .font-extrabold {
    font-weight: 900 !important;
  }

  .font-light {
    font-weight: 300 !important;
  }

  .font-normal {
    font-weight: 400 !important;
  }

  .font-semibold {
    font-weight: 600 !important;
  }

  .font-bold {
    font-weight: 700 !important;
  }

  .no-underline {
    text-decoration: none;
  }

  .underline {
    text-decoration-line: underline;
  }

  .text-underline {
    text-decoration: underline;
  }
  
  .drag-handle {
    display: flex;
    width: 12px;
    padding: 15px;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    touch-action: none;
    cursor: var(--cursor, pointer);
    border-radius: 5px;
    border: none;
    outline: none;
    appearance: none;
    background-color: transparent;
    -webkit-tap-highlight-color: transparent;
  }

  .hidden {
    display: none;
  }
  .gap-2 {
    gap: 0.5rem;
  }
  .gap-3 {
    gap: 0.75rem;
  }
  .gap-12 {
    grid-gap: 0.75rem;
  }
  .input-fit .ant-form-item-control-input {
    min-height: fit-content !important;
  }
  .terminal-card {
    flex: 0 0 14.5%;
  }
  .ant-modal div[aria-hidden="true"] {
    display: none;
  }
`;
